import { plannedToAnchorDate } from '@/shared/lib/datetime/planned-date';
import { resolveTimelineBarColor } from './timeline-bar-color';
import type {
  TaskSummaryDto,
  TimelineAbsenceBlock,
  TimelineMilestoneDto,
  TimelinePersonRowModel,
} from '../types';

/** Groups tasks by assignee into swimlanes; folds milestones/absences into their matching row. */
export function buildPersonRows(
  tasks: TaskSummaryDto[],
  milestones: TimelineMilestoneDto[],
  absenceBlocks: TimelineAbsenceBlock[],
): TimelinePersonRowModel[] {
  const rowsById = new Map<string, TimelinePersonRowModel>();

  for (const task of tasks) {
    if (!task.assignee) continue;
    const personId = task.assignee.id;
    let row = rowsById.get(personId);
    if (!row) {
      row = {
        person: {
          id: personId,
          name: task.assignee.displayName ?? '—',
          avatarUrl: task.assignee.avatarUrl ?? undefined,
        },
        tasks: [],
        milestones: [],
        absenceBlocks: [],
      };
      rowsById.set(personId, row);
    }
    if (task.startDate && task.dueDate) {
      row.tasks.push({
        id: task.id,
        title: task.title,
        startDate: plannedToAnchorDate(task.startDate),
        endDate: plannedToAnchorDate(task.dueDate),
        color: resolveTimelineBarColor(personId),
        isCompleted: task.isCompleted,
      });
    }
  }

  for (const milestone of milestones) {
    rowsById.get(milestone.personUserId)?.milestones.push(milestone);
  }
  for (const block of absenceBlocks) {
    rowsById.get(block.userId)?.absenceBlocks.push(block);
  }

  return [...rowsById.values()];
}
